<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState} from "vuex";
import { ModelListSelect } from "vue-search-select";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Reconcile Agent Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Agent Stock Taking",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: " Agent Stock Take",
          active: true,
        },
      ],
      totalRows: 1,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "agent.name",
          sortable: true,
          label: "AGENT",
        },
        {
          key: "name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "instock",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "actual_quantity",
          sortable: true,
          label: "ACTUAL QUANTITY",
        },
        {
          key: "units",
          sortable: true,
          label: "UNIT QTY RECONCILE",
        }
      ],

      // Value from user input for adding position
      inputs: {
        product_id:"",
        added_qty: "",
        type: "",
        agent: "",
        agent_id:""
      },
      stock_ar: [],
      filterStock:{
        agent: 0
      },
    };
  },
  computed: {
          // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("agentstock", ["AgentStock", "SaveStatus","Agents"]),
    ...mapGetters("auth", ["MyUserPerm"]),
  },

  watch: {
    AgentStock(newValue) {
      if (newValue) {
        this.assiginData();
      }
    },
  },

  methods: {
    ...mapActions({
      FetchToReconcile: "agentstock/fetchAgentstock",
      ReconcileStock: "agentstock/addQty",
      SaveReconcile: "agentstock/SaveReconcile",
      FetchAgents: "agentstock/fetchAgents",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assiginData() {
      this.stock_ar = this.AgentStock;
    },
    
    saveReconcile(event, product, index, agent) {
      this.inputs.product_id = product;
      this.inputs.actual_qty = event;
      this.inputs.type=0;
      this.inputs.agent=this.filterStock.agent;
      this.inputs.agent_id=agent;
      if (this.inputs.actual_qty != "") {
        this.ReconcileStock(this.inputs).then(() => { 
          this.$refs[index]?this.$refs[index].value = '':'';       
        });
      }
    },
    FilterAgentstock(){
        this.FetchToReconcile(this.filterStock.agent);
    },
    StockReconcile() {
        this.SaveReconcile(this.filterStock.agent).then(() => {
            this.FetchToReconcile(this.filterStock.agent);
        });
    },
  },
  created() {
    this.FetchToReconcile(this.filterStock.agent);
    this.FetchAgents();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-3">
                <div class="col-md-5 form-group">
                <label>SEARCH FOR AGENT</label>
                
                <model-list-select
                    :list="Agents ? Agents : []"
                    v-model="filterStock.agent"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Agent"
                    @input="FilterAgentstock()"
                >
                </model-list-select>
                </div>
              <!-- Search -->
              <div class="col-md-7">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="stock_ar ? stock_ar : []"
                :fields="fields"
                responsive="sm"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(instock)="data">
                  {{ data.item.instock }} {{ data.item.units[0].unit.name }}
                </template>
                <template #cell(actual_quantity)="data">
                  {{ data.item.actual_quantity}} {{data.item.actual_quantity?data.item.units[0].unit.name:''}}
                </template>
                <template #cell(units)="data">
                  <tr >
                    <td>{{data.item.units[0].unitsym}}</td>
                    <td>
                      <input
                      :ref="data.index"
                      type="number"
                      class="custom"
                      @blur="saveReconcile($event.target.value, data.item.product_id, data.index, data.item.agent.id)"
                      placeholder="Enter Actual Value"
                    />
                    </td>
                  </tr>
                  </template>
              </b-table>
            </div>
            <center>
                <Loader v-if="!AgentStock" />
              </center>
            <div class="row">
              <div v-if="MyUserPerm.reconcile_agentstock == 1" class="col-12 mr-3">
                <button @click="StockReconcile()" class="btn btn-primary float-end bt">
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom {
  width: 150px;
  height: 30px;
  margin-right: 2px;
  box-sizing: border-box;
  padding: 12px 5px;
}
.bt {
  margin-right: 120px;
  margin-top: 40px;
}
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
